export const API_ROOT = 'https://japi.five.obu.tourismusnetz.com/obu/api/v1';